import React  from 'react'
import RefExampleDestination from './RefExampleDestination';


export default class RefExampleOtherChild extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        this.state = {
        };
    }

    componentDidMount() 
    {
        
    }

    render()
    {
        
        return (
            <div className='border bg-success p-2 m-2'>
                <div>This is the RefExampleOtherChild component.</div>
                <RefExampleDestination 
                    testProp="Valami"
                    ref={this.props.callRef}
                /> 
            </div>

        );
    }
}

